// extracted by mini-css-extract-plugin
export default {"boxInput":"_1Ccdk","boxInput__range":"_31NmL","boxInput__inputField":"_2RU4E","applyBtn":"_39YlX"};